import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { TerminalLoading } from './components/TerminalLoading/TerminalLoading';

const App = React.lazy(() => import('./App'));

const container = document.getElementById('root');
const app = React.createElement(
  Suspense,
  {
    fallback: React.createElement(TerminalLoading),
  },
  React.createElement(App),
);

if (container) {
  ReactDOM.render(app, container);
}
